import { CubicEase, Animation, EasingFunction, } from "@babylonjs/core";
// Helper function to normalize angle within [0, 2 * Math.PI]
function normalizeAngle(angle) {
    return angle - Math.floor(angle / (2 * Math.PI)) * 2 * Math.PI;
}
// Function to calculate the shortest rotation path
function calculateShortestPathAlpha(currentAlpha, targetAlpha) {
    let deltaAlpha = targetAlpha - currentAlpha;
    if (Math.abs(deltaAlpha) > Math.PI) {
        if (deltaAlpha > 0) {
            deltaAlpha -= 2 * Math.PI;
        }
        else {
            deltaAlpha += 2 * Math.PI;
        }
    }
    return currentAlpha + deltaAlpha;
}
// Camera animation function
export function changeCamera(camera, scene, targetCameraPosition, framesRate, action) {
    const startFrame = 0;
    const endFrame = 100;
    const frameRate = framesRate;
    // Normalize the camera's alpha and target alpha
    const normalizedCurrentAlpha = normalizeAngle(camera.alpha);
    const normalizedTargetAlpha = normalizeAngle(targetCameraPosition.alpha);
    // Calculate the shortest path for alpha
    const finalTargetAlpha = calculateShortestPathAlpha(normalizedCurrentAlpha, normalizedTargetAlpha);
    const cameraAlpha = new Animation("cameraAlpha", "alpha", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const cameraBeta = new Animation("cameraBeta", "beta", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const cameraRadius = new Animation("cameraBeta", "radius", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const cameraTargetX = new Animation("cameraTargetX", "target.x", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const cameraTargetY = new Animation("cameraTargetY", "target.y", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const cameraTargetZ = new Animation("cameraTargetZ", "target.z", frameRate, Animation.ANIMATIONTYPE_FLOAT, Animation.ANIMATIONLOOPMODE_CYCLE);
    const alphaKeyFrames = [
        { frame: startFrame, value: normalizedCurrentAlpha },
        { frame: endFrame, value: finalTargetAlpha },
    ];
    const betaKeyFrames = [
        { frame: startFrame, value: camera.beta },
        { frame: endFrame, value: targetCameraPosition.beta },
    ];
    const radiusKeyFrames = [
        { frame: startFrame, value: camera.radius },
        { frame: endFrame, value: targetCameraPosition.radius },
    ];
    const targetXKeyFrames = [
        { frame: startFrame, value: camera.target.x },
        { frame: endFrame, value: targetCameraPosition.x },
    ];
    const targetYKeyFrames = [
        { frame: startFrame, value: camera.target.y },
        { frame: endFrame, value: targetCameraPosition.y },
    ];
    const targetZKeyFrames = [
        { frame: startFrame, value: camera.target.z },
        { frame: endFrame, value: targetCameraPosition.z },
    ];
    cameraAlpha.setKeys(alphaKeyFrames);
    cameraBeta.setKeys(betaKeyFrames);
    cameraRadius.setKeys(radiusKeyFrames);
    cameraTargetX.setKeys(targetXKeyFrames);
    cameraTargetY.setKeys(targetYKeyFrames);
    cameraTargetZ.setKeys(targetZKeyFrames);
    const easingFunction = new CubicEase();
    easingFunction.setEasingMode(EasingFunction.EASINGMODE_EASEINOUT);
    cameraAlpha.setEasingFunction(easingFunction);
    cameraBeta.setEasingFunction(easingFunction);
    cameraRadius.setEasingFunction(easingFunction);
    cameraTargetX.setEasingFunction(easingFunction);
    cameraTargetY.setEasingFunction(easingFunction);
    cameraTargetZ.setEasingFunction(easingFunction);
    scene.beginDirectAnimation(camera, [
        cameraRadius,
        cameraAlpha,
        cameraBeta,
        cameraTargetX,
        cameraTargetY,
        cameraTargetZ,
    ], startFrame, endFrame, false, 1, action);
}
